import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Row, Col, Button, ButtonGroup, Glyphicon, Popover, OverlayTrigger, DropdownButton, MenuItem } from 'react-bootstrap'
import Logger from '../stores/Logger'
import { listFilterModes } from '../stores/IdeaStore'
import { dueDateModes } from '../stores/IdeaStore'
import CardList from '../components/CardList'
import Dashboard from './Dashboard'
import '../containers/css/IdeaList.css'
import { majorModes } from './Header'
import CompactList from './CompactList'
import VideoModal from '../components/VideoModal'

export const listModes = Object.freeze({
    compact:1,
    rich:2,
    card:3,
    dash:4,
    storage: 5,
})

class IdeaList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            searchBarText: '',
            ideaListButtonGroupStyle: 'viewModeButtons',
            listButtonGroupStyling: 'listButtonGroup',
            listContainerStyle: 'listContainer',
            margin: 0,
            loaded: false,
        }
        this.handleSearchClick = this.handleSearchClick.bind(this)
        this.changeSort = this.changeSort.bind(this)
        this.changeFilter = this.changeFilter.bind(this)
        this.showNonTeamIdeas = this.showNonTeamIdeas.bind(this)
    }

    doUpdate() {
        setTimeout(() => {
            this.forceUpdate()
        }, 500)
    }
    componentWillMount() {
        const { stores } = this.props
        const { routingStore } = stores
        const { push } = routingStore
        push('/ideas/')
    }
    shouldComponentUpdate() {
        const { store } = this.props.stores
        const {
            loadingIdeas,
        } = store
        return !loadingIdeas
    }
    componentWillReceiveProps(nextProps) {
        const { params } = nextProps
        if (params.ideaGroup && this.props.stores.prefStore.loadedPrefs === true) {
            this.updateIdeasViewed(params.ideaGroup)
        }
        //This is used in case the list is really long and needs a vertical scrollbar
        //If the scrollbar appears, it pushes content to the left
        //This causes the layout to adjust properly again. Only does it once!
        this.doUpdate()
    }
    componentDidUpdate(prevProps) {
        const { store, prefStore } = this.props.stores
        const { majorMode } = prefStore

        const {
            loadingIdeas,
        } = store

        if (loadingIdeas === false && majorMode !== majorModes.ideas && this.state.listContainerStyle === 'listContainer') {
            this.setState({ listContainerStyle: 'listContainerDashboard' })
        }
        else if (loadingIdeas === false && majorMode === majorModes.ideas && this.state.listContainerStyle === 'listContainerDashboard') {
            this.setState({ listContainerStyle: 'listContainer' })
        }
    }
    componentDidMount() {
        // console.log('componentDidMount',this.props)
        const { stores } = this.props
        const { store, authStore, notificationStore } = stores
        // console.log('componentDidMount()')
        this.unwatchAuth = authStore.watchAuth(user => {
            if (user) {
                //    console.log('calling loadIdeas')
                notificationStore.saveMessagingDeviceToken()
            } else {
                console.log('logged out!')
                store.logout()
            }
        }, error => {
            console.log('watchAuth error: ' + JSON.stringify(error))
        })
    }
    componentWillUnmount() {
        if (this.unwatchAuth) {
            this.unwatchAuth()
            this.unwatchAuth = null
        }
    }
    newIdea(e) {
        const { routingStore } = this.props.stores
        const { push } = routingStore
        Logger.trackEvent('newIdeaStarted')
        push('/idea/new')
    }
    updateIdeasViewed(ideaGroup) {
        this.props.stores.prefStore.ideaGroup = ideaGroup
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('updateIdeasViewed', 'ideaGroup', ideaGroup)
    }
    changeSearchBarText(e) {
        this.setState({ searchBarText: e.target.value })
    }
    handleSearchClick() {
        if (this.state.searchBarText !== undefined && this.state.searchBarText !== ''){
            this.props.stores.prefStore.listSearchText = this.state.searchBarText
            this.props.stores.prefStore.storeUserPreferences()
            this.setState({searchBarText: ''})
            Logger.trackEvent('filterIdeas', 'filterString', this.state.searchBarText)
        }
    }
    filter(e) {
        if (e.key === 'Enter') {
            if (this.state.searchBarText !== undefined && this.state.searchBarText !== ''){
                this.props.stores.prefStore.listSearchText = this.state.searchBarText
                this.props.stores.prefStore.storeUserPreferences()
                this.setState({searchBarText: ''})
                Logger.trackEvent('filterIdeas', 'filterString', this.state.searchBarText)
            }
        }
    }
    showCompact(e) {
        this.props.stores.prefStore.viewMode = listModes.compact
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('showCompact')
        this.doUpdate()
    }
    showCard(e) {
        this.props.stores.prefStore.viewMode = listModes.card
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('showCard')
        this.doUpdate()
    }
    changeFilter(filterText) {
        const { stores } = this.props
        const { store } = stores
        store.handleFilterChange(filterText)
    }
    changeSort(sortType) {
        const { stores } = this.props
        const { store } = stores
        store.handleSortChange(sortType)
    }
    showNonTeamIdeas(showNonTeamIdeas){
        if(showNonTeamIdeas === false){
            this.props.stores.prefStore.showNonTeamIdeas = 3
        } else {
            this.props.stores.prefStore.showNonTeamIdeas = false
        }
        this.props.stores.prefStore.storeUserPreferences()
    }
    render() {
        const { store, authStore, prefStore } = this.props.stores
        const {
            filter,
            filteredResponsibleIdeas,
            filteredAllIdeas,
            filteredWorkOnIdeas,
            filteredTeamSharedIdeaArray,
            responsibleIdeaArray,
            workOnIdeaArray,
            allIdeas,
            teamSharedIdeaArray,
            loadingIdeas,
            loadingOwnIdeas,
        } = store
        const {
            compactPref,
            cardPref,
            ideaGroup,
            majorMode,
            viewMode,
            dashOrder,
        } = prefStore
        let sortIcon = ''
        let team = authStore.auth.primaryTeam
        let dueDateMode = prefStore.dueDateMode
        let sortType = dueDateMode
        let title = ''
        switch (sortType) {
            case dueDateModes.sortBy:
                title = 'Sort by'
                sortIcon = 'chevron-down'
                break
            case dueDateModes.byWeek:
                title = 'By week'
                sortIcon = 'remove'
                break
            case dueDateModes.byMonth:
                title = 'By month'
                sortIcon = 'remove'
                break
            case dueDateModes.byYear:
                title = 'By year'
                sortIcon = 'remove'
                break
            default:
                title = 'Sort by'
                sortIcon = 'chevron-down'
                break
        }

        // const userProfile = authStore.userProfile()
        var canAddIdea = true
        // if(userProfile && userProfile.plan_details){
        //     canAddIdea = (userProfile.idea_count < userProfile.plan_details.idea_limit) ? true : false
        // }
        let filteredIdeasToShow, unfilteredIdeasToShow, noIdeasText
        filteredIdeasToShow = []

        let listFilter = prefStore.listFilterMode
        let listSearch = prefStore.listSearchText
        let involveNonTeamIdeas = prefStore.showNonTeamIdeas
        //Team ideas should not show for non team users, dashboard dissapears when filter is active and no ideas exist
        switch (listFilter) {
            case listFilterModes.allIdeas:
                filteredIdeasToShow = filteredAllIdeas
                unfilteredIdeasToShow = allIdeas
                noIdeasText =
                    (<div>
                        <h2>You have no ideas in PRE.DO yet.</h2>
                        <h3>Go ahead and create one now</h3>
                    </div>)
                break
            case listFilterModes.workOn:
                filteredIdeasToShow = filteredWorkOnIdeas
                unfilteredIdeasToShow = workOnIdeaArray
                noIdeasText =
                    (<div>
                        <h2>You have no ideas you work on in PRE.DO yet.</h2>
                        <h3>Go ahead and create one or join someone else's idea</h3>
                    </div>)
                break
            case listFilterModes.teamIdeas:
                filteredIdeasToShow = filteredTeamSharedIdeaArray
                unfilteredIdeasToShow = teamSharedIdeaArray
                noIdeasText =
                    (<div>
                        <h2>You have no team ideas in PRE.DO yet.</h2>
                        <h3>Go ahead and create one yourself now, and share with your team.</h3>
                    </div>)
                break
            case listFilterModes.responsibleFor:
            default:
                filteredIdeasToShow = filteredResponsibleIdeas
                unfilteredIdeasToShow = responsibleIdeaArray
                noIdeasText =
                    (<div>
                        <h2>You have no ideas you are responsible for in PRE.DO yet.</h2>
                        <h3>Go ahead and create one now - you will become responsible for it automatically until somebody else is assigned</h3>
                    </div>)
                break
        }

        var div = document.getElementById('ideaList')
        let margin = 0
        if (div) {
            if (div.clientHeight + 100 > window.innerHeight) {
                margin = 0
            }
            else if (window.innerWidth < 1451) {
                margin = 0
            }
            else {
                margin = -8
            }
        }
        if (majorMode === majorModes.progress) {
            margin = 0
        }

        let theViewMode = viewMode ? viewMode : listModes.card
        //Add componentWillMount so that the filter mode changes the tag text
        let popoverFilter = (
            <Popover className='filterPopover' id='popover-positioned-bottom'>
                <div className='filterPopoverLeft'>
                    <span>
                        My involvement
                    </span>
                </div>

                <div className='filterPopoverRight'>
                    <div className='bg'>
                        <div onClick={() => this.changeFilter(listFilterModes.responsibleFor)} className='chiller_cb'>
                            <input id='myCheckbox' type='checkbox' readOnly checked={listFilter === listFilterModes.responsibleFor}/>
                            <label style={{fontWeight: 500, cursor: 'pointer'}}>Show ideas I am responsible for</label>
                            <span></span>
                        </div>
                    </div>

                    <div style={{ marginTop: 10 + 'px' }} className='bg'>
                        <div onClick={() => this.changeFilter(listFilterModes.workOn)} className='chiller_cb'>
                        <input id='myCheckbox' type='checkbox' value={listFilterModes.workOn} readOnly checked={listFilter === listFilterModes.workOn}/>
                            <label style={{fontWeight: 500, cursor: 'pointer'}}>Show ideas I work on</label>
                            <span></span>
                        </div>
                    </div>

                    {(team && team.hasOwnProperty('members') > 0) &&
                        <div style={{ marginTop: 10 + 'px' }} className='bg'>
                            <div onClick={() => this.changeFilter(listFilterModes.teamIdeas)} className='chiller_cb'>
                                <input id='myCheckbox' type='checkbox' readOnly checked={listFilter === listFilterModes.teamIdeas}/>
                                <label style={{fontWeight: 500, cursor: 'pointer'}}>Show ideas I do not work on</label>
                                <span></span>
                            </div>
                        </div>
                    }
                    {(team && team.hasOwnProperty('members') > 0) &&
                        <div>
                            <hr></hr>
                            <div style={{ marginTop: 10 + 'px' }} className='bg'>
                                <div onClick={() => this.showNonTeamIdeas(involveNonTeamIdeas)} className='chiller_cb'>
                                    <input id='myCheckbox' type='checkbox' readOnly checked={involveNonTeamIdeas === false}/>
                                    <label style={{fontWeight: 500, cursor: 'pointer'}}>Show team ideas only</label>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Popover>
        )

        return (
            <div id='ideaList' style={{ marginLeft: margin + 'px' }} className='ideaListContainer'>
                <Row className={this.state.listContainerStyle}>
                    {loadingIdeas !== true &&
                        <Col className='searchFilterContainer'>
                            <div className='ideaListSearchBar'>
                                {store.isLoggedIn &&
                                    <div className='searchContainer'>
                                        <input className='searchInput' style={{ border: '1px solid #ccc' }} type='text' placeholder='Search' value={this.state.searchBarText} onKeyPress={this.filter.bind(this)} onChange={this.changeSearchBarText.bind(this)} />
                                        <Glyphicon className='searchInputIcon' glyph='search' onClick={() => this.handleSearchClick()} />
                                    </div>
                                }
                            </div>
                            <div className='ideaListFilter'>
                                <OverlayTrigger className='popoverTrigger' trigger='click' rootClose placement='bottom' overlay={popoverFilter}>
                                    <div className='filterContainer'>
                                        <span>Filter ideas by </span>
                                        <Glyphicon className='filterIcon' glyph='filter' />
                                    </div>
                                </OverlayTrigger>
                            </div>
                            {listFilter > listFilterModes.allIdeas &&
                                <div className='filterTagContainer'>
                                    <div className='filterTags'>
                                        <div onClick={() => store.deleteFilterTag()} className='deleteFilterTagButton'>
                                            x
                                        </div>
                                        {store.returnFilterTag()}
                                    </div>
                                </div>
                            }
                            <div className='filterTagContainer'>
                                {(listSearch !== null && listSearch !== '') &&
                                    <div className='filterTags'>
                                        <div onClick={() => store.deleteSearchTag()} className='deleteFilterTagButton'>
                                            x
                                        </div>
                                        "{listSearch}"
                                    </div>
                                }
                            </div>
                            <span>
                                <VideoModal
                                    videoTitle='Find your Idea'
                                    videoURL='https://www.youtube.com/watch?v=OSr3uI6GlLU'

                                />
                            </span>
                        </Col>
                    }
                    {(majorMode === majorModes.progress && dashOrder === "Due date") &&
                        <Col className='sortContainer'>
                            <div className='ideaListSort'>
                                <DropdownButton className='ideaListDropdown' id='dropdown-custom-1' title={title} noCaret>
                                    <MenuItem id='menuItemByWeek' eventKey='1' onClick={() => this.changeSort(dueDateModes.byWeek)}>By week</MenuItem>
                                    <MenuItem id='menuItemByMonth' eventKey='2' onClick={() => this.changeSort(dueDateModes.byMonth)}>By month</MenuItem>
                                    <MenuItem id='menuItemByYear' eventKey='3' onClick={() => this.changeSort(dueDateModes.byYear)}>By year</MenuItem>
                                </DropdownButton>
                                {(sortIcon!=='chevron-down' )&&
                                    <Glyphicon style={{position: 'absolute', right:'7px', zIndex: 600, paddingTop: '10px', height: '100%'}} onClick={() => { this.changeSort(dueDateModes.sortBy) }} className='sortIcon' glyph={sortIcon} />
                                }
                                {(sortIcon==='chevron-down' )&&
                                    <Glyphicon style={{position: 'absolute', right:'7px', top: '11px'}} className='sortIcon' glyph={sortIcon} />
                                }
                            </div>
                        </Col>
                    }
                    {(majorMode === majorModes.ideas && loadingIdeas !== true && prefStore.viewMode !== listModes.storage) &&
                        <Col className='viewButtonContainer'>
                            <div className={this.state.ideaListButtonGroupStyle}>
                                <ButtonGroup className={this.state.listButtonGroupStyling}>
                                    <Button
                                        className='ideaListGroupButton'
                                        onClick={(e) => this.showCompact(e)}
                                        active={theViewMode === listModes.compact}
                                    >
                                        <Glyphicon glyph='align-justify' />
                                    </Button>
                                    <Button
                                        className='ideaListGroupButton'
                                        onClick={(e) => this.showCard(e)}
                                        active={theViewMode === listModes.card}
                                    >
                                        <Glyphicon glyph='th' />
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Col>
                    }
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <div>
                            {store.online &&
                                <div className='loadingIdeasText'>
                                    {loadingIdeas ? (
                                        <div>
                                            <h2>Loading ideas...</h2>
                                        </div>
                                    ) : (
                                            <div>
                                                {unfilteredIdeasToShow.length === 0 &&
                                                    <div style={{ marginBottom: 20 + 'px' }}>
                                                        {noIdeasText}
                                                        <Button bsStyle='primary' disabled={!canAddIdea} block onClick={(e) => this.newIdea(e)}>
                                                            <Glyphicon glyph='plus' /> New Idea
                                                    </Button>
                                                    </div>
                                                }
                                                {((filteredIdeasToShow.length === 0) && (unfilteredIdeasToShow.length > 0)) &&
                                                    <div className='searchNotFound'>
                                                        <h4>Your search - <em>{filter}</em> - did not match any ideas.</h4>
                                                    </div>
                                                }
                                            </div>
                                        )}
                                </div>
                            }
                        </div>
                    </Col>
                </Row>
                {(majorMode === majorModes.ideas && theViewMode === listModes.compact) &&
                    <Row className='filteredIdeas'>
                        {filteredIdeasToShow !== null &&
                            <CompactList
                                filteredIdeasToShow={filteredIdeasToShow}
                                compactPref={compactPref}
                                loadingOwnIdeas={loadingOwnIdeas}
                                ideaGroup={ideaGroup}
                                viewMode={theViewMode}
                            />
                        }
                    </Row>
                }
                {(majorMode === majorModes.ideas && theViewMode === listModes.card) &&
                    <Row>
                        {filteredIdeasToShow !== null &&
                            <CardList showFields={cardPref} filteredIdeasToShow={filteredIdeasToShow} />
                        }
                    </Row>
                }
                {majorMode === majorModes.progress &&
                    <div style={{ width: 100 + '%' }}>
                        {unfilteredIdeasToShow !== null && unfilteredIdeasToShow.length > 0 &&
                        <div>
                            <Dashboard
                                filteredIdeasToShow={filteredIdeasToShow}
                            />
                        </div>
                        }
                    </div>
                }
            </div>
        )
    }
}
IdeaList.propTypes = {
    stores: PropTypes.object.isRequired,
    ideaGroup: PropTypes.string,
}

export default inject("stores")(observer(IdeaList))


// WEBPACK FOOTER //
// ./src/containers/IdeaList.js